(function () {
  'use strict';

  if (window.__collectionQuickAddInit) return;
  window.__collectionQuickAddInit = true;

  var ATC_SELECTOR = '[data-main-collection-grid-add-to-cart], [data-featured-products-add-to-cart]';
  var SOLDOUT_CLASSES = ['btn--soldout', 'is-soldout'];
  var initialized = new WeakSet();
  var variantCache = new WeakMap();

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.money_format);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function getVariants(optionsWrap) {
    var tag = optionsWrap.querySelector('.collection-variants-data');
    if (!tag) return [];
    var cached = variantCache.get(tag);
    if (cached && cached.source === tag.textContent) return cached.variants;
    try {
      var variants = JSON.parse(tag.textContent);
      if (!Array.isArray(variants)) return [];
      variantCache.set(tag, { source: tag.textContent, variants: variants });
      return variants;
    } catch (e) {
      return [];
    }
  }

  function getSelection(optionsWrap) {
    var selection = [
      optionsWrap.dataset.defaultOption1 || null,
      optionsWrap.dataset.defaultOption2 || null,
      optionsWrap.dataset.defaultOption3 || null
    ];
    optionsWrap.querySelectorAll('[data-option-position]').forEach(function (group) {
      var pos = Number(group.dataset.optionPosition);
      if (pos < 1 || pos > 3) return;
      var active = group.querySelector('button.is-active[data-option-value]');
      var select = group.querySelector('select.collection-option-select');
      if (active) selection[pos - 1] = active.dataset.optionValue;
      else if (select) selection[pos - 1] = select.value;
    });
    return selection;
  }

  function optionValue(variant, index) {
    return variant['option' + (index + 1)] || null;
  }

  function rankVariant(variant) {
    if (!variant.available) return 2;
    return variant.preorder ? 1 : 0;
  }

  function preferredVariant(variants) {
    return variants.reduce(function (best, variant) {
      return !best || rankVariant(variant) < rankVariant(best) ? variant : best;
    }, null);
  }

  function matchingVariants(variants, selection) {
    return variants.filter(function (variant) {
      return selection.every(function (value, index) {
        return value == null || optionValue(variant, index) === value;
      });
    });
  }

  function resolveVariant(optionsWrap, changedPosition) {
    var variants = getVariants(optionsWrap);
    var selection = getSelection(optionsWrap);
    var exact = preferredVariant(matchingVariants(variants, selection));
    if (exact) return exact;
    if (!changedPosition) return preferredVariant(variants);
    var candidates = variants.filter(function (variant) {
      return optionValue(variant, changedPosition - 1) === selection[changedPosition - 1];
    });
    var best = null;
    var bestScore = -1;
    candidates.forEach(function (variant) {
      var score = selection.reduce(function (total, value, index) {
        return total + (index !== changedPosition - 1 && value != null && optionValue(variant, index) === value ? 1 : 0);
      }, 0);
      if (!best || score > bestScore || (score === bestScore && rankVariant(variant) < rankVariant(best))) {
        best = variant;
        bestScore = score;
      }
    });
    return best;
  }

  function syncSelection(optionsWrap, variant) {
    if (!variant) return;
    for (var index = 0; index < 3; index++) {
      optionsWrap.dataset['defaultOption' + (index + 1)] = optionValue(variant, index) || '';
    }
    optionsWrap.querySelectorAll('[data-option-position]').forEach(function (group) {
      var value = optionValue(variant, Number(group.dataset.optionPosition) - 1);
      group.querySelectorAll('button[data-option-value]').forEach(function (button) {
        var active = button.dataset.optionValue === value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      var select = group.querySelector('select.collection-option-select');
      if (select) select.value = value || '';
    });
    optionsWrap.dataset.selectedVariantId = String(variant.id);
  }

  function markUnavailable(optionsWrap, variants, selection) {
    optionsWrap.querySelectorAll('[data-option-position]').forEach(function (group) {
      var pos = Number(group.dataset.optionPosition);
      if (pos < 1 || pos > 3) return;
      function candidates(value) {
        return variants.filter(function (variant) { return optionValue(variant, pos - 1) === value; });
      }
      group.querySelectorAll('button[data-option-value]').forEach(function (button) {
        var matches = candidates(button.dataset.optionValue);
        var available = matches.some(function (variant) { return variant.available; });
        button.classList.toggle('is-unavailable', !available);
        if (!matches.length) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
      });
      var select = group.querySelector('select.collection-option-select');
      if (select) Array.from(select.options).forEach(function (option) {
        option.disabled = !candidates(option.value).length;
      });
    });
  }

  function getStrings(optionsWrap) {
    var s = window.variantStrings || {};
    var data = optionsWrap ? optionsWrap.dataset : {};
    return {
      addToCart: data.addLabel || s.addToCart || 'Add to cart',
      preorder: data.preorderLabel || s.preorder || s.preOrder || s.addToCart || 'Add to cart',
      soldOut: data.soldOutLabel || s.soldOut || 'Sold out',
      unavailable: data.unavailableLabel || s.unavailable || 'Unavailable',
      save: data.saveLabel || 'Save'
    };
  }

  function findLabelTextNode(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3 && node.nodeValue && node.nodeValue.trim()) return node;
    }
    return null;
  }

  function setButtonText(btn, text) {
    var label = btn.querySelector('[data-chic-card-button-label], [data-rv-btn-text]');
    if (label) {
      label.textContent = text;
      return;
    }
    var node = findLabelTextNode(btn);
    if (node) node.nodeValue = ' ' + text + ' ';
    else btn.insertBefore(document.createTextNode(' ' + text + ' '), btn.firstChild);
  }

  function snapshotDefaultText(btn, optionsWrap) {
    if (btn.dataset.qaDefaultText) return;
    var node = findLabelTextNode(btn);
    var strings = getStrings(optionsWrap);
    var label = btn.querySelector('[data-chic-card-button-label], [data-rv-btn-text]');
    var current = label ? label.textContent.trim() : node ? node.nodeValue.trim() : '';
    btn.dataset.qaDefaultText = current && current !== strings.soldOut && current !== strings.unavailable && current !== strings.preorder ? current : strings.addToCart;
  }

  function applyAtcState(btn, variant, optionsWrap) {
    snapshotDefaultText(btn, optionsWrap);
    var strings = getStrings(optionsWrap);
    var unavailable = !variant || !variant.available;
    btn.dataset.variantId = variant ? String(variant.id) : '';
    SOLDOUT_CLASSES.forEach(function (name) { btn.classList.toggle(name, unavailable); });
    if (unavailable) btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
    if (btn.tagName === 'BUTTON') btn.disabled = unavailable;
    setButtonText(btn, !variant ? strings.unavailable : !variant.available ? strings.soldOut : variant.preorder ? strings.preorder : (btn.dataset.qaDefaultText || strings.addToCart));
  }

  function toggleBadge(badge, visible) {
    badge.hidden = !visible;
    badge.style.display = visible ? '' : 'none';
  }

  function syncPrice(card, variant, optionsWrap) {
    var price = Number(variant.price) || 0;
    var compare = Number(variant.compare_at_price) || 0;
    var onSale = variant.available && compare > price;
    card.querySelectorAll('.product-price').forEach(function (el) {
      el.textContent = variant.priceFormatted || formatMoney(price);
    });
    card.querySelectorAll('.product-compare-price').forEach(function (el) {
      el.textContent = compare > price ? variant.compareFormatted || formatMoney(compare) : '';
      el.style.display = compare > price ? '' : 'none';
      el.hidden = compare <= price;
    });
    var saveLabel = getStrings(optionsWrap).save;
    card.querySelectorAll('.product-save-badge, [data-badge-save-percent]').forEach(function (el) {
      el.textContent = saveLabel + ' ' + (compare > price ? Math.round((compare - price) * 100 / compare) : 0) + '%';
      toggleBadge(el, onSale);
    });
    card.querySelectorAll('[data-badge-save-amount]').forEach(function (el) {
      el.textContent = saveLabel + ' ' + formatMoney(compare - price);
      toggleBadge(el, onSale);
    });
    card.querySelectorAll('[data-badge-sale]').forEach(function (el) { toggleBadge(el, onSale); });
  }

  function imageIdentity(value) {
    try {
      var url = new URL(value, window.location.href);
      url.searchParams.delete('width');
      url.searchParams.sort();
      return url.href;
    } catch (e) { return value; }
  }

  function cardImageSrcset(value, nativeWidth) {
    try {
      var url = new URL(value, window.location.href);
      var ownImage = url.origin === window.location.origin && /^\/cdn\/shop\/(?:files|products|collections)\//.test(url.pathname);
      var shopifyImage = url.hostname === 'cdn.shopify.com' && /^\/s\/files\//.test(url.pathname);
      if (url.protocol !== 'https:' || (!ownImage && !shopifyImage)) return '';
      var maximum = Math.round(Math.min(Number(nativeWidth) || Number(url.searchParams.get('width')) || 1200, 1200));
      if (maximum < 1) return '';
      var widths = [180, 360, 540, 720, 960, 1200].filter(function (width) { return width < maximum; });
      widths.push(maximum);
      return widths.map(function (width) {
        var candidate = new URL(url.href);
        candidate.searchParams.set('width', String(width));
        return candidate.href + ' ' + width + 'w';
      }).join(', ');
    } catch (e) { return ''; }
  }

  function syncImage(card, optionsWrap, variant) {
    var image = card.querySelector('img.primary-image, .product__image img.original-image, .card__media-full-spacer img, .card__inner .media img');
    var nextImage = variant.image;
    if (!nextImage && !optionsWrap.dataset.defaultVariantId) {
      var active = optionsWrap.querySelector('.collection-swatch-dot.is-active[data-variant-image]');
      nextImage = active && active.dataset.variantImage;
    }
    if (!image || !nextImage) return;
    var sameImage = imageIdentity(image.getAttribute('src') || image.src) === imageIdentity(nextImage);
    var nextSrcset = variant.imageSrcset;
    if (!nextSrcset && (!sameImage || !image.getAttribute('srcset'))) {
      nextSrcset = cardImageSrcset(nextImage, variant.imageWidth);
    }
    if (variant.imageSizes) image.sizes = variant.imageSizes;
    else if (!image.getAttribute('sizes')) image.sizes = '(max-width: 749px) calc(50vw - 17px), (max-width: 1199px) 33vw, 25vw';
    if (nextSrcset) image.srcset = nextSrcset;
    else if (!sameImage) image.removeAttribute('srcset');
    if (!sameImage) image.src = nextImage;
    if (variant.imageAlt !== undefined) image.alt = variant.imageAlt;
    if (variant.imageWidth) image.width = Number(variant.imageWidth);
    if (variant.imageHeight) image.height = Number(variant.imageHeight);
    image.style.display = '';
    var wrapper = image.closest('.product-image-wrapper, .product__image, .media');
    if (wrapper && wrapper.classList.contains('--adapt-media') && variant.imageWidth && variant.imageHeight) {
      wrapper.style.setProperty('--adapt-aspect-ratio-value', Number(variant.imageWidth) / Number(variant.imageHeight));
    }
    card.querySelectorAll('.placeholder-image').forEach(function (el) { el.style.display = 'none'; });
    card.querySelectorAll('.secondary-image, .hover-secondary-image').forEach(function (el) {
      el.hidden = true;
      el.style.display = 'none';
    });
    card.querySelectorAll('.has_second-img, .has-second-image').forEach(function (el) {
      el.classList.remove('has_second-img', 'has-second-image');
    });
  }

  function syncLinks(card, optionsWrap, variant) {
    var productUrl = variant.url || optionsWrap.dataset.productUrl;
    if (!productUrl) return;
    var selected;
    try {
      selected = new URL(productUrl, window.location.href);
      selected.searchParams.set('variant', String(variant.id));
    } catch (e) { return; }
    var productPath = selected.pathname.split('/products/')[1];
    card.querySelectorAll('a[href]').forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.href);
        if (url.origin !== selected.origin || !productPath || url.pathname.split('/products/')[1] !== productPath) return;
        url.searchParams.set('variant', String(variant.id));
        link.href = url.pathname + url.search + url.hash;
        if (link.hasAttribute('data-replace-url')) link.dataset.replaceUrl = link.getAttribute('href');
      } catch (e) {}
    });
    var url = selected.pathname + selected.search + selected.hash;
    card.dataset.selectedVariantId = String(variant.id);
    card.dataset.qaProductUrl = url;
    card.querySelectorAll(ATC_SELECTOR).forEach(function (button) { button.dataset.productUrl = url; });
    card.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.value = String(variant.id);
    });
    if (card.hasAttribute('onclick') || card.dataset.cardClickable === 'true') {
      card.onclick = function (event) {
        if (event.defaultPrevented || event.target.closest('a, button, input, select, textarea, label, .collection-options')) return;
        window.location.href = card.dataset.qaProductUrl;
      };
    }
  }

  function updateCard(optionsWrap, variant) {
    var card = optionsWrap.closest('.product-item, .product, .card-wrapper');
    if (!card) return;
    card.querySelectorAll(ATC_SELECTOR).forEach(function (button) { applyAtcState(button, variant, optionsWrap); });
    card.querySelectorAll('[data-rv-product-url-btn]').forEach(function (button) { applyAtcState(button, variant, optionsWrap); });
    if (!variant) return;
    syncSelection(optionsWrap, variant);
    syncPrice(card, variant, optionsWrap);
    syncImage(card, optionsWrap, variant);
    syncLinks(card, optionsWrap, variant);
    card.querySelectorAll('[data-badge-availability="sold_out"]').forEach(function (el) { toggleBadge(el, !variant.available); });
    card.querySelectorAll('[data-badge-availability="preorder"]').forEach(function (el) { toggleBadge(el, variant.available && variant.preorder === true); });
    card.querySelectorAll('.product-badges-wrap[data-max-count]').forEach(function (wrap) {
      var limit = Math.max(1, Number(wrap.dataset.maxCount) || 1);
      var shown = 0;
      wrap.querySelectorAll('[data-badge-availability], [data-badge-sale], [data-badge-save-amount], [data-badge-save-percent]').forEach(function (badge) {
        if (badge.hidden) return;
        shown++;
        if (shown > limit) toggleBadge(badge, false);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('button[data-option-value]');
    if (!button) return;
    var wrap = button.closest('.collection-options');
    var group = button.closest('[data-option-position]');
    if (!wrap || !group) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    group.querySelectorAll('button[data-option-value]').forEach(function (el) {
      el.classList.toggle('is-active', el === button);
      el.setAttribute('aria-pressed', String(el === button));
    });
    var variant = resolveVariant(wrap, Number(group.dataset.optionPosition));
    updateCard(wrap, variant);
    markUnavailable(wrap, getVariants(wrap), getSelection(wrap));
  }, true);

  document.addEventListener('change', function (event) {
    var select = event.target.closest('select.collection-option-select');
    if (!select) return;
    var wrap = select.closest('.collection-options');
    var group = select.closest('[data-option-position]');
    if (!wrap || !group) return;
    event.stopImmediatePropagation();
    updateCard(wrap, resolveVariant(wrap, Number(group.dataset.optionPosition)));
    markUnavailable(wrap, getVariants(wrap), getSelection(wrap));
  }, true);

  function initAll(root) {
    root = root && root.querySelectorAll ? root : document;
    var wraps = Array.from(root.querySelectorAll('.collection-options'));
    if (root.matches && root.matches('.collection-options')) wraps.unshift(root);
    wraps.forEach(function (wrap) {
      if (initialized.has(wrap)) return;
      var variants = getVariants(wrap);
      if (!variants.length) return;
      initialized.add(wrap);
      var selected = variants.find(function (variant) { return String(variant.id) === wrap.dataset.defaultVariantId; });
      updateCard(wrap, selected || preferredVariant(variants));
      markUnavailable(wrap, variants, getSelection(wrap));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('collection:rendered', function () { initAll(); });
  document.addEventListener('chic:cards:updated', function (event) { initAll(event.target); });

  if ('MutationObserver' in window) {
    var pending = new Set();
    var scheduled = false;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.from(mutation.addedNodes).forEach(function (node) {
          if (node.nodeType !== 1) return;
          if ((node.matches && node.matches('.collection-options')) || (node.querySelector && node.querySelector('.collection-options'))) pending.add(node);
        });
      });
      if (!pending.size || scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        pending.forEach(function (node) { if (node.isConnected) initAll(node); });
        pending.clear();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function showToast(message, type) {
    var t = document.createElement('div');
    t.className = 'collection-toast collection-toast--' + (type || 'info');
    t.setAttribute('role', type === 'error' ? 'alert' : 'status');
    t.textContent = message;
    document.body.appendChild(t);
    requestAnimationFrame(function () {
      t.classList.add('is-visible');
    });
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () {
        if (t.parentNode) t.parentNode.removeChild(t);
      }, 300);
    }, 2400);
  }

  function setLoading(btn) {
    btn.dataset.qaState = 'loading';
    btn.classList.remove('is-success', 'is-error');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    try {
      btn.dataset.qaQuickAdd = '1';
    } catch (e) {}
  }

  function clearState(btn) {
    btn.classList.remove('is-loading', 'is-success', 'is-error');
    btn.removeAttribute('aria-busy');
    delete btn.dataset.qaState;
    try {
      delete btn.dataset.qaQuickAdd;
    } catch (e) {}
  }

  function setSuccess(btn) {
    btn.classList.remove('is-loading');
    btn.classList.add('is-success');
    btn.setAttribute('aria-busy', 'false');
    btn.dataset.qaState = 'success';
    setTimeout(function () {
      clearState(btn);
    }, 1400);
  }

  function setError(btn) {
    btn.classList.remove('is-loading');
    btn.classList.add('is-error');
    btn.setAttribute('aria-busy', 'false');
    btn.dataset.qaState = 'error';
    setTimeout(function () {
      clearState(btn);
    }, 1500);
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest(ATC_SELECTOR);
      if (!btn) return;

      var hasSoldOut =
        btn.classList.contains('btn--soldout') || btn.classList.contains('is-soldout');
      var hasNoVariant = !btn.dataset.variantId;

      if (hasSoldOut || hasNoVariant) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var strings = getStrings();
        showToast(hasSoldOut ? strings.soldOut : strings.unavailable, 'error');
        return;
      }

      if (btn.dataset.qaState === 'loading') return;
      setLoading(btn);

      setTimeout(function () {
        if (btn.dataset.qaState === 'loading') {
          setError(btn);
          showToast('Could not add to cart. Please try again.', 'error');
        }
      }, 6000);
    },
    true
  );

  document.addEventListener('cart:updated', function () {
    document.querySelectorAll(ATC_SELECTOR + '.is-loading').forEach(function (btn) {
      if (btn.dataset && btn.dataset.qaQuickAdd === '1') setSuccess(btn);
    });
  });

  function patchVanillaCart() {
    var vcs = window.VanillaCartState;
    if (!vcs || typeof vcs.addItem !== 'function' || vcs.__quickAddPatched) return;
    var orig = vcs.addItem.bind(vcs);
    vcs.addItem = function () {
      var args = arguments;
      return orig.apply(null, args).catch(function (err) {
        document.querySelectorAll(ATC_SELECTOR + '.is-loading').forEach(function (btn) {
          if (btn.dataset && btn.dataset.qaQuickAdd === '1') setError(btn);
        });
        showToast(
          (err && err.message) || 'This item could not be added to your cart.',
          'error'
        );
        throw err;
      });
    };
    vcs.__quickAddPatched = true;
  }

  patchVanillaCart();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchVanillaCart);
  }
  setTimeout(patchVanillaCart, 0);
  setTimeout(patchVanillaCart, 500);
})();

